// extracted by mini-css-extract-plugin
module.exports = {"borderedFooter":"AllCommentsTabContainer-borderedFooter-3d62d2991e14cdbc517066f495db4fff"};